export default __webpack_public_path__ + "static/media/kitAlarma1.e77ef492.png";